import foundationCss from '@/assets/styles/foundation-emails-2.2.1.min.extcss?raw';

/**
 * Ember's `{% include_foundation_css %}` liquid tag — the backend expands it
 * into the Foundation-for-Emails stylesheet when an email actually sends.
 *
 * Matched the way Liquid tokenizes a tag rather than as one exact string, since
 * both renderers register it as a real tag: LiquidJS on `/v3` (`render`
 * `liquidJS/src/controllers/liquidController.js`) and Ruby Liquid on the legacy
 * path (`render` `config/initializers/liquid_tags.rb`,
 * `Liquid::Template.register_tag('include_foundation_css', FoundationCSSTag)`).
 * The unspaced `{%include_foundation_css%}` therefore expands on both, and
 * `{%- include_foundation_css -%}` expands on LiquidJS. A preview matching only
 * the canonical spelling would show a hand-written layout without the styles it
 * actually ships with.
 *
 * Matching the trim form is still safe on the legacy path, which does not
 * support it: `customerio/liquid` 2.5.4 predates whitespace control, so a
 * leading `{%-` is a parse error there — that body fails to render at all
 * rather than sending without Foundation.
 *
 * No `{%+ … +%}`: liquidjs rejects it as illegal tag syntax, so it expands
 * nowhere. The one direction this over-matches is a tag disabled with
 * `{% comment %}` or `{% raw %}`, which still previews with the stylesheet.
 * Both are unchanged from the behavior before conditional injection, so neither
 * is a regression.
 *
 * Global, so a single `replace` covers a body carrying the tag more than once.
 * Use it only with `replace`/`replaceAll`, which reset `lastIndex`; `test` and
 * `exec` on a shared global regex alternate between hit and miss.
 */
export const FOUNDATION_LIQUID_TAG = /\{%-?\s*include_foundation_css\s*-?%\}/g;

/**
 * The Foundation stylesheet as an inline `<style>` block for the preview.
 *
 * A `<link>` to the bundled `.extcss` asset does NOT work inside the preview
 * `srcdoc` iframes: the dev/prod server serves `.extcss` with a non-CSS MIME
 * type (`application/json`), so the browser loads the file but refuses to
 * apply it as a stylesheet — leaving the email with only its inline styles
 * (unconstrained, full-bleed). Inlining the CSS as a `<style>` block sidesteps
 * both the MIME check and `srcdoc`'s base-URL resolution of relative hrefs.
 */
export const FOUNDATION_CSS_STYLE_TAG = `<style>${foundationCss}</style>`;
